import { ConfigProvider } from 'antd';
import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import App from './app';
import './app/i18n';
import i18n from './app/i18n';
import theme from './app/theme';
import './index.css';
import PageSpinner from './shared/components/page-spinner/page-spinner';
import { store, storePersistor } from './store/store';
import { detectLocale } from './shared/utils/detect-locale/detect-locale';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <HelmetProvider>
      <ReduxProvider store={store}>
        <PersistGate persistor={storePersistor} loading={<></>}>
          <BrowserRouter>
            <ConfigProvider
              form={{
                requiredMark: false,
                scrollToFirstError: {
                  behavior: 'smooth',
                  block: 'center',
                  inline: 'center',
                },
              }}
              theme={theme}
              locale={detectLocale(i18n.language)}
            >
              <Suspense fallback={<PageSpinner />}>
                <App />
              </Suspense>
            </ConfigProvider>
          </BrowserRouter>
        </PersistGate>
      </ReduxProvider>
    </HelmetProvider>
  </StrictMode>,
);
